import React from 'react';
import { IOrderLinkProps, OrderLink } from './OrderLink';
import { eApplicationActions } from 'state/orderOverview/actions';
import { SmallBodyText } from 'ui-toolkit';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { useApplicationContext } from 'state/orderOverview/context';
import { SummaryItemWithLink } from '../../../../../shared/Summary/SummaryItem/SummaryItemWithLink';
import { eOrderLinkType } from '../../../../../../ui-toolkit/enums/eOrderLinkType';
import { eInternalOrderStatus } from '../../../../../../ui-toolkit/enums/eInternalOrderStatus';
import { IOrderLinkItem } from '../../../../../../ui-toolkit/orders/interfaces/IOrderLinkItem';

export const OrderAssociationSummaryItemContainer: React.FC = (props) => {
  const { data } = useSelectCurrentOrder();
  const { transaction, orderInformation } = data;
  const [, dispatch] = useApplicationContext();

  const onAssociate = () =>
    dispatch({ type: eApplicationActions.ChangeValues, payload: { showAssociateOrderWithId: transaction.id! } });
  const orderLinksProps = orderInformation.orderLinks.map<IOrderLinkProps & { id: string }>((orderLink) => {
    const { clientIntent, status } =
      orderLink.items.find((i) => i.orderId === transaction.id) || ({} as IOrderLinkItem);
    const id = orderLink.id;
    const associatedOrder = orderLink.items.find((i) => i.orderId !== transaction.id) || ({} as IOrderLinkItem);
    const associatedOrderType = (
      (orderLink.type === eOrderLinkType.search_acquisition ? null : associatedOrder.clientIntent) || ''
    ).replace(/^(.)/, (str) => str.toUpperCase());
    const associatedOrderId = associatedOrder.orderId;
    const associatedOrderNumber = associatedOrder.fileNumber.toString();
    const associatedOrderCancelled = associatedOrder.status === eInternalOrderStatus.cancelled;
    const orderCancelled = status === eInternalOrderStatus.cancelled;
    const orderType =
      orderLink.type === eOrderLinkType.acquisition_resale
        ? clientIntent.replace(/^(.)/, (str) => str.toUpperCase())
        : undefined;
    const onDisassociate = () =>
      dispatch({ type: eApplicationActions.ChangeValues, payload: { showDisassociateOrderWithId: orderLink.id } });
    return {
      id,
      associatedOrderId,
      associatedOrderNumber,
      associatedOrderType,
      associatedOrderCancelled,
      onDisassociate,
      orderType,
      orderCancelled,
    };
  });
  return (
    <SummaryItemWithLink onClick={onAssociate} label={'Order Association'} tab={'summary'}>
      {orderLinksProps.length > 0 ? (
        orderLinksProps.map(({ id, ...orderLinkProps }) => {
          return <OrderLink key={id} {...orderLinkProps} />;
        })
      ) : (
        <SmallBodyText intent={`faded`}>-</SmallBodyText>
      )}
    </SummaryItemWithLink>
  );
};
